/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { useDexFetchClient } from '@/api/looker/utils/use-dex-fetch-client';
import { useMe } from '@/hooks/use-me';

export namespace GetLevels {
  export const key = () => ['data-explorer', 'get-levels'];

  export type QueryParams = {
    retry?: number | boolean;
  };

  export type Output = {
    levels: {
      top: string;
      unit: string;
    };
  };

  export type FetchResult = Record<
    string,
    { top_level: string; unit_level: string }
  >;

  function outputFromBody(data: FetchResult): Output {
    const [{ top_level, unit_level }] = Object.values(data);

    return {
      levels: { top: top_level, unit: unit_level },
    };
  }

  export function useQuery({ retry }: QueryParams = {}) {
    const fetchClient = useDexFetchClient();
    const me = useMe();

    return rq.useQuery<Output>({
      retry,
      queryKey: key(),
      async queryFn({ signal }) {
        const data = await fetchClient<FetchResult>({
          path: `/v1/levels/${me.tenant}`,
          signal,
        });

        return outputFromBody(data);
      },
    });
  }
}
